<template>
  <!-- Loader -->
  <div class="progress" v-if="!isReady">
    <div class="indeterminate"></div>
  </div>

  <!-- Adding Principal -->
  <LoadingDiv v-if="isSubmitting" />

  <div class="card z-depth-0 single-add-card" v-else>
    <div class="card-content red" v-if="error">
      <div class="input-field">
        <h6 class="white-text center">
          {{ error }}
        </h6>
      </div>
    </div>

    <form @submit.prevent="handleSubmit">
      <div class="card-content">
        <div class="row">
          <div class="col s10">
            <div class="file-field input-field">
              <div class="btn grey">
                <span>Change</span>
                <input type="file" @change="handleFile" />
              </div>
              <div class="file-path-wrapper">
                <input class="file-path" v-model="inputFile" type="text" />
                <p v-if="fileError">{{ fileError }}</p>
              </div>
            </div>
          </div>
          <div class="col s2">
          <LoadingSmallDiv v-if="isLoading" />
          <span v-else>
            <img
              :src="img"
              width="64"
              class="circle responsive-img"
              v-if="img"
            />
              <img
                src="https://ui-avatars.com/api/?name=P&size=128"
                width="64"
                class="circle responsive-img"
                v-else
              />
          </span>
        </div>
        </div>
      </div>

      <div class="card-panel">
        <div class="row">
          <div class="col s12">
        <div class="input-field">
          <input type="text" v-model="name" class="validate" required />
          <label class="active teal-text" for="name">Principal Name <i class="tiny material-icons pointable orange-text" title="required">star</i></label>
        </div>
        </div>  
        </div>
      </div>

      <div class="card-panel">
        <div class="row">
          <div class="col s12">
        <div class="input-field">
          <label class="active teal-text" for="sex">Sex  <i class="tiny material-icons pointable orange-text" title="required">star</i></label>
          <select id="sex" v-model="sex" class="validate" required>
            <option value="m">Male</option>
            <option value="f">Female</option>
          </select>
        </div>
        </div>
        </div>  
      </div>

      <div class="card-panel">
        <div class="row">
        <div class="input-field col s12 m2">
          <input id="day" type="number" v-model="birthDay" min="1" max="31" class="validate" />
          <label class="active teal-text" for="day">Birth Day</label>
        </div>
        <div class="input-field col s12 m6">
          <label class="active teal-text" for="month">Birth Month</label>
           <select id="month" v-model="birthMonth" class="validate">
            <option value="" selected>Select Month</option>
            <option value="1">January</option>
            <option value="2">February</option>
             <option value="3">March</option>
            <option value="4">April</option>
             <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
             <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>
        </div>
        <div class="input-field col s12 m4">
          <input id="year" type="number" v-model="birthYear" min="1900" class="validate" />
          <label class="active teal-text" for="year">Birth Year</label>
        </div>
        </div>
        <div class="age-policy-note" v-if="ageError">
          <i class="material-icons">policy</i>
          <span>{{ ageError }}</span>
        </div>
      </div>

     <div class="card-panel">
      <div class="row">
          <div class="col s12">
      <div class="input-field">
        <input type="text" v-model="enrolleeNumber" />
        <label class="active teal-text" for="email">Enrollee ID</label>
      </div>
      </div>
      </div>
    </div>

      <div class="card-panel">
        <div class="row">
        <div class="input-field col s12 m6">
          <input type="email" v-model="email" class="validate" />
          <label class="active teal-text" for="email">Email</label>
        </div>
        <div class="input-field col s12 m6">
          <input type="text" v-model="phone" class="validate" />
          <label class="active teal-text" for="phone">Phone</label>
        </div>
      </div>
      </div>

      <div class="card-panel">
        <div class="row">
          <div class="col s12">
        <div class="input-field">
          <input type="text" v-model="address" class="validate" />
          <label class="active teal-text" for="address">Address</label>
        </div>
        </div>
        </div>
      </div>

      <div class="card-panel">
        <div class="row">
        <div class="input-field col s12 m6">
          <label class="active teal-text" for="plan">Plan  <i class="tiny material-icons pointable orange-text" title="required">star</i></label>
          <select id="plan" v-model="plan" class="validate" @change="type = null" required>
            <option v-for="plan in plans" :key="plan.id" :value="plan.id">
              {{ plan.name }}
            </option>
          </select>
        </div>
        <div class="input-field col s12 m6">
          <label class="active teal-text" for="type">Type  <i class="tiny material-icons pointable orange-text" title="required">star</i></label>
          <select id="type" v-model="type" class="validate" required>
            <option value="i" v-if="hasPlanType('i')">Individual</option>
            <option value="f" v-if="hasPlanType('f')">Family</option>
          </select>
        </div>
      </div>
      </div>

      <!-- load provider select -->
      <ProviderDiv
        :userPlanPoints="userPlanPoints"
        @update="handleUpdate"
        v-if="plan && cat == 'tpa'"
      />

      <div class="card grey lighten-5">
        <div class="row">
          <button
            class="waves-effect waves-light btn-large col s12 m3"
            :class="{
              disabled:
                !name || !sex || !plan || !type || !isReady || isSubmitting || ageError,
            }"
          >
            <i class="material-icons right">check_circle</i
            >{{ isSubmitting ? "Adding" : "Add Principal" }}
          </button>
          <span class="col m9"></span>
        </div>
      </div>
    </form>
  </div>
</template>
  
<script>
import { onMounted, onUpdated, ref, watchEffect, computed } from "vue";
import postItem from "@/composables/postItem";
import getItemsOfItems from "@/composables/getItemsOfItems";
import useStorage from "@/composables/useStorage";
import ProviderDiv from "@/components/client/tpa/ProviderSelectTPAComponent.vue";
import LoadingDiv from "@/components/LoadingDiv.vue";
import LoadingSmallDiv from "@/components/LoadingSmallDiv.vue";
import M from "materialize-css";

export default {
  name: "EnrolleeSingleOnboardComponent",
  components: { LoadingDiv, LoadingSmallDiv, ProviderDiv },
  props: ["cat", "clientId"],
  emits: ["complete"],
  setup(props, context) {
    const response = ref(null);
    const policyResponse = ref(null);
    const policyServerDate = ref(null);
    const userPlanPoints = ref(null);
    const file = ref(null);
    const inputFile = ref(null);
    const fileError = ref(null);
    const name = ref(null);
    const sex = ref(null);
    const birthDay = ref(null);
    const birthMonth = ref(null);
    const birthYear = ref(null);
    const enrolleeNumber = ref(null);
    const email = ref(null);
    const phone = ref(null);
    const address = ref(null);
    const plan = ref(null);
    const provider = ref(0);
    const type = ref(null);
    const isReady = ref(false);
    const isSubmitting = ref(false);
    const isLoading = ref(false);
    const error = ref(null);
    const img = ref(null);
    const types = ["image/jpg", "image/jpeg", "image/png", "image/gif"];
    const parseLocalDate = (value) => {
      if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split("-").map(Number);
        return new Date(year, month - 1, day);
      }

      return new Date(value);
    };
    const buildDob = () => {
      const pad = (n) => String(n).padStart(2, "0");
      const y = birthYear.value;
      const m = birthMonth.value;
      const d = birthDay.value;

      if (y == null || m == null || d == null || y === "" || m === "" || d === "") {
        return null;
      }

      const dateStr = `${y}-${pad(m)}-${pad(d)}`;
      const date = parseLocalDate(dateStr);
      const isValid =
        !isNaN(date) &&
        date.getFullYear() === Number(y) &&
        date.getMonth() + 1 === Number(m) &&
        date.getDate() === Number(d);

      return isValid ? dateStr : null;
    };
    const calculateAge = (value) => {
      if (!value) return null;

      const date = parseLocalDate(value);
      if (isNaN(date)) return null;

      const today = referenceDate.value;
      let age = today.getFullYear() - date.getFullYear();
      const monthDiff = today.getMonth() - date.getMonth();

      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
        age -= 1;
      }

      return age;
    };

    // storage
    const { uploadFile, uploadProgress, uploadError, data, completed } =
      useStorage();

    // get function
    const getItemsFromApi = (table, match) => {
      (async () => {
        const { res, err } = await getItemsOfItems(table, match);

        if (res.value) {
          // suspend as per cat
          if (props.cat != "tpa") {
            response.value = res.value.data.filter(
              (x) => Array.isArray(x.premiums) && x.premiums?.find((p) => p.type == "i" && p.amount > 0) // using indiidual plan as weight
            ); // remove suspended (zeros)
          } else {
            response.value = res.value.data.filter(
              (x) => Array.isArray(x.premiums) && x.premiums?.find((p) => p.type == "i" && p.amount == 0) // using indiidual plan as weight
            ); // remove suspended (premium amounts)
          }
        } else {
          error.value = err.value;
        }

        // page is ready, loading is complete
        isReady.value = true;
        isLoading.value = false;
      })();
    };

    // get current policy
    const getPolicyFromApi = () => {
      (async () => {
        const { res, err } = await getItemsOfItems("policy/client", props.clientId);

        if (res.value) {
          policyResponse.value = res.value.data;
          policyServerDate.value = res.value.server;
        } else {
          error.value = err.value;
        }
      })();
    };

    // starter
    onMounted(() => {
      // start from the top
      getItemsFromApi("plan/client/plans", props.clientId);
      getPolicyFromApi();
    });

    // select
    onMounted(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });

    // select
    onUpdated(() => {
      // activate select field
      const elemsSelect = document.querySelectorAll("select");
      M.FormSelect.init(elemsSelect, {});
    });

     // clear
     const clearForm = () => {
      file.value = null; //clear file value
      inputFile.value = null; // Clear the file input value
      isSubmitting.value = false;
      isLoading.value = false;
      uploadProgress.value = "0%";
    };

    // restart
    const resetForm = () => {
      file.value = null; //clear file value
      inputFile.value = null; // Clear the file input value
      isLoading.value = false;
      uploadProgress.value = "0%";
      name.value = null;
      sex.value = null;
      birthDay.value = null;
      birthMonth.value = null;
      birthYear.value = null;
      enrolleeNumber.value = null;
      img.value = null;
      email.value = null;
      phone.value = null;
      address.value = null;
      plan.value = null;
      type.value = null;
    };

    // handle file
    const handleFile = (e) => {
      const selected = e.target.files[0];
      if (selected && types.includes(selected.type)) {
        file.value = selected;
        inputFile.value = file.value.name;
        fileError.value = null;
      } else {
        file.value = null;
        inputFile.value = null;
        fileError.value = "Please select an Image (.JPG, .PNG, .GIF)";
      }
    };

    const handleData = () => {
      // console.log("data");
    };

    // update provider
    const handleUpdate = (val) => {
      if (val) {
        provider.value = val;
      } else {
        provider.value = 0;
      }
    };

    //hand
    watchEffect(() => {
      if (plan.value) {
        // start ploading
        let userPlan = plans.value.filter((x) => x.id == plan.value);
        let userPlanPointsArray = userPlan[0].premiums
          .filter((x) => x.scope === 0 && x.type === "i")
          .reduce((a, b) =>
            new Date(a.created_at) > new Date(b.created_at) ? a : b
          );
        // finalize
        userPlanPoints.value = userPlanPointsArray?.amount;
      } else {
        // null
        userPlanPoints.value = null;
      }
    });

    //hand
    watchEffect(() => {
      if (file.value) {
        // start ploading
        isLoading.value = true;
        uploadError.value = null;

        // upload image
        uploadFile(file.value);
      }
    });

    //handle submit
    const handleSubmit = async () => {
      // Materialize CSS handled all custome errors \\

      // start
      isSubmitting.value = true;
      error.value = false;
      uploadProgress.value = false;

      if (ageError.value) {
        error.value = ageError.value;
        isSubmitting.value = false;
        return;
      }

      let newDOB = buildDob();

      // variable
      const newVal = {
        name: name.value,
        sex: sex.value,
        dob: newDOB,
        enrollee_number: enrolleeNumber.value,
        email: email.value || null,
        phone: phone.value,
        address: address.value,
        profile_img: img.value,
        plan_id: plan.value,
        provider_id: provider.value,
        client_id: props.clientId,
        type: type.value,
      };

      // post item
      const { res, err } = await postItem("principal", newVal);

      if (res.value) {
        // success
        M.toast({
          html: "Principal added. Record now in Lobby.",
          classes: "teal darken-1 white-text",
        });
        resetForm();
        context.emit("complete");
      } else {
        // failure
        error.value = err.value || "Sorry, something went wrong!";
      }
      // clear submitting
      isSubmitting.value = false;
    };

    // watch tariff upload
    watchEffect(() => {
      if (completed.value) {
        // set image
        img.value = data.value;
            // clear
            clearForm();
        // data.succ.Success, data.succ.inserted_rows, data.succ.Error
        // console.log(data); // might not be necessary
      }
      if (uploadError.value) {
        // clear
        clearForm();
      }
    });

    // all enrollees
    const plans = computed(() => {
      if (!response.value) {
        return [];
      } else {
        return response.value;
      }
    });

    const hasPlanType = (selectedType) => {
      const selectedPlan = plans.value?.find((p) => p.id === plan.value);
      return !!selectedPlan?.premiums?.find((x) => {
        if (x.type != selectedType) return false;
        return props.cat == "tpa" ? x.amount == 0 : x.amount > 0;
      });
    };

    const currentPolicy = computed(() => {
      const policies = Array.isArray(policyResponse.value) ? policyResponse.value : [];
      return (
        policies.find((policy) => policy.status == "a") ||
        policies.find((policy) => policy.status == "p") ||
        policies[0] ||
        null
      );
    });

    const referenceDate = computed(() => {
      const date = policyServerDate.value ? parseLocalDate(policyServerDate.value) : new Date();
      return isNaN(date) ? new Date() : date;
    });

    const principalAgeLimit = computed(() => Number(currentPolicy.value?.principal_age) || 0);

    const memberAge = computed(() => calculateAge(buildDob()));

    const ageError = computed(() => {
      if (!principalAgeLimit.value || memberAge.value === null) return null;
      if (memberAge.value > principalAgeLimit.value) {
        return `Principal age exceeds the current policy limit of ${principalAgeLimit.value} years.`;
      }
      return null;
    });

    return {
      handleFile,
      handleData,
      handleUpdate,
      handleSubmit,
      isReady,
      isSubmitting,
      isLoading,
      error,
      uploadProgress,
      fileError,
      uploadError,
      file,
      inputFile,
      userPlanPoints,
      img,
      name,
      sex,
      birthDay,
      birthMonth,
      birthYear,
      enrolleeNumber,
      email,
      phone,
      address,
      type,
      provider,
      plan,
      plans,
      hasPlanType,
      ageError,
    };
  },
};
</script>
    
<style scoped>
.progress {
  margin-top: -15px; /* Adjust the value as needed to move the progress bar upwards */
}

.single-add-card {
  border: 0;
  box-shadow: none;
}

.single-add-card .card-panel {
  border: 1px solid #eeeeee;
  border-radius: 6px;
  box-shadow: none;
  margin-bottom: 14px;
}

.single-add-card form > .card.grey {
  border-radius: 6px;
  box-shadow: none;
  margin-top: 14px;
  padding: 16px;
}

.age-policy-note {
  align-items: center;
  background: #fff3e0;
  border-left: 4px solid #ef6c00;
  border-radius: 4px;
  color: #4e342e;
  display: flex;
  gap: 10px;
  margin-top: 14px;
  padding: 10px 12px;
}

.age-policy-note i {
  color: #ef6c00;
  font-size: 20px;
}
</style>
